import Phaser from 'phaser'
import { Monsters } from '../Story/Monsters';
import { Arcs } from '../Story/Arc';
import SelectLevelScene from './SelectLevelScene';
import ImageHelpers from '../GUI/ImageHelpers';
import BackButton from '../GUI/BackButton';

/**
 * An arc has levels
 * This scene selects the level in an arc.
 */
export default class SelectArcScene extends Phaser.Scene {
    private mBackground: Phaser.GameObjects.Image;

    private mArcButtons: Phaser.GameObjects.Image[];
    private mArcTitles: Phaser.GameObjects.Text[];
    private mBackButton!: BackButton;

    constructor() {
        super('SelectArcScene');
    }

    preload() {
        this.load.image('selectLevelBackground', 'images/Arcs/SelectLevel.png');
        Monsters.preload(this);
        Arcs.preload(this);

        this.mArcButtons = [];
        this.mArcTitles = [];

        // For now load manually until a way to config it?
        this.load.image(`selectArcIconArc_1_The_Beginning.png`, `images/Arcs/Arc_1_The_Beginning.png`);
        this.load.image(`1_practice_background.png`, `images/Levels/1_practice_background.png`);
        this.load.image(`1_practice_icon.png`, `images/Levels/1_practice_icon.png`);
        this.load.image(`2_sewage_icon.png`, `images/Levels/2_sewage_icon.png`);
        this.load.image(`2_sewage_background.png`, `images/Levels/2_sewage_background.png`);
        this.load.image(`3_sewage_deeper_icon.png`, `images/Levels/3_sewage_deeper_icon.png`);
        this.load.image(`3_sewage_deeper_background.png`, `images/Levels/3_sewage_deeper_background.png`);
        this.load.image(`4_high_annoyance_icon.png`, `images/Levels/4_high_annoyance_icon.png`);
        this.load.image(`4_high_annoyance.png`, `images/Levels/4_high_annoyance.png`);
        this.load.image(
          `5_annoying_boars_icon.png`,
          `images/Levels/5_annoying_boars_icon.png`,
        );
        this.load.image(
          `5_annoying_boars.png`,
          `images/Levels/5_annoying_boars.png`,
        );
        
        BackButton.preload(this);
    }

    create() {
        let width = this.cameras.main.width;
        let height = this.cameras.main.height;
        this.mBackground = this.add.image(width / 2, height / 2, "selectLevelBackground");
        this.mBackground.setDisplaySize(width, height);
        this.mBackground.setDepth(-1);

        Arcs.create(this);
        let thisScene = this;

        let arcsTitle = thisScene.add.text(0, 0, "Arcs", { fontSize: 60, color: "white", fontStyle: "bold" })
        arcsTitle.setX(thisScene.scale.width / 2 - arcsTitle.width / 2);

        Arcs.Arcs.forEach(arc => {

            let icon = this.add.image(arc.MapAreaX, arc.MapAreaY, `selectArcIcon${arc.Icon}`);
            ImageHelpers.SetHoverEffectOnImage(thisScene, icon);
            thisScene.mArcButtons.push(icon);
            let text = thisScene.add.text(arc.MapAreaX - 110, arc.MapAreaY + 100, arc.Name, { fontSize: 30, color: "white", fontStyle: "bold" });
            thisScene.mArcTitles.push(text);

            icon.setInteractive()
                .on('pointerdown', () => {
                    const configs = arc.LevelConfigs;
                    const data = { Configuration: configs, ArcFolder: arc.ConfigFolder };
                    this.cameras.main.fade(200);

                    this.time.delayedCall(205, () => {
                        if (this.scene.get('SelectLevelScene')) {
                            this.scene.start('SelectLevelScene', data);
                        } else {
                            this.scene.add('SelectLevelScene', new SelectLevelScene(), true, data);
                        }
                        this.scene.stop('SelectArcScene');
                    });
                });

            // arc.LevelConfigs.forEach(levelConfig =>{

            //     let lvlConfigFile = `configuration/arcs/${arc.ConfigFolder}/${levelConfig.ConfigurationFile}`;
            //     thisScene.load.json('mobsData', lvlConfigFile);
            // });
        });

        this.mBackButton = new BackButton(this, "MainMenu"); // default bottom-left
    }

    update() {
        let thisScene = this;
        if (thisScene === null || thisScene.input === null || thisScene.input.keyboard === null) {
            return;
        }

        var keyObj = thisScene.input.keyboard.addKey('Esc');  // Get key object
        var isDown = keyObj.isDown;
        if (isDown) {
            this.scene.start('MainMenu');
        }
    }
}